import { useState, useEffect } from "react";
import { List, X, WhatsappLogo } from "@phosphor-icons/react";
import { BRAND, buildWhatsAppLink } from "../lib/brand";

const NAV = [
  { href: "#materiais", label: "Materiais" },
  { href: "#confianca", label: "Por que nós" },
  { href: "#avaliacao", label: "Avaliação" },
  { href: "#galeria", label: "Galeria" },
  { href: "#localizacao", label: "Localização" },
  { href: "#faq", label: "FAQ" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled
          ? "bg-[rgba(10,10,10,0.85)] backdrop-blur-md border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="navbar-brand"
          className="flex items-center gap-2.5"
        >
          <span className="w-8 h-8 grid place-items-center bg-[var(--rc-copper)] text-black font-display font-bold">
            R
          </span>
          <span className="font-display font-bold tracking-tight text-white text-lg">
            Ricatto<span className="text-[var(--rc-copper-bright)]">.</span>Metais
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.href.replace("#", "")}`}
              className="text-sm font-medium text-zinc-300 hover:text-white transition-colors"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <a
          data-testid="navbar-whatsapp-btn"
          href={buildWhatsAppLink()}
          target="_blank"
          rel="noopener noreferrer"
          className="hidden lg:inline-flex items-center gap-2 rc-btn-whatsapp px-4 py-2.5 rounded-full text-sm"
        >
          <WhatsappLogo size={18} weight="fill" /> {BRAND.phoneDisplay}
        </a>

        <button
          data-testid="navbar-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden w-10 h-10 grid place-items-center text-white border border-white/15"
          aria-label="Abrir menu"
        >
          {open ? <X size={20} weight="bold" /> : <List size={20} weight="bold" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-[var(--rc-surface)]">
          <div className="px-4 py-4 flex flex-col gap-1">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-link-${n.href.replace("#", "")}`}
                className="py-3 px-2 text-zinc-200 border-b border-white/5 font-medium"
              >
                {n.label}
              </a>
            ))}
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-navbar-whatsapp-btn"
              className="mt-3 rc-btn-whatsapp px-4 py-3 rounded-full text-sm text-center inline-flex items-center justify-center gap-2"
            >
              <WhatsappLogo size={18} weight="fill" /> Falar no WhatsApp
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
